// src/pages/VerifyEmailPage.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
const STRAPI_URL = process.env.REACT_APP_STRAPI_URL;

function getToken() {
  try {
    const p = new URLSearchParams(window.location.search);
    return (
      p.get('confirmation') ||
      p.get('token') ||
      p.get('code') ||
      p.get('confirmationToken') ||
      ''
    );
  } catch { return ''; }
}

export default function VerifyEmailPage() {
  const [status, setStatus] = useState('Bevestiging verwerken…');
  const [token, setToken] = useState('');

  useEffect(() => {
    const t = getToken();
    setToken(t);

    if (!t) {
      setStatus('Geen bevestigingstoken gevonden.');
      return;
    }

    axios
      .get(`${STRAPI_URL}/api/auth/email-confirmation`, { params: { confirmation: t } })
      .then(() => {
        setStatus('Je e-mailadres is bevestigd. Je kunt nu inloggen.');
      })
      .catch((err) => {
        const status = err?.response?.status;
        const name = (err?.response?.data?.error?.name || '').toLowerCase();
        const message = (err?.response?.data?.error?.message || '').toLowerCase();

        // Veelvoorkomend: mailclient heeft al geklikt → token “op”
        const looksAlready =
          status === 400 ||
          status === 409 ||
          name.includes('already') ||
          message.includes('already') ||
          message.includes('confirm');

        if (looksAlready) {
          setStatus('Je e-mailadres is bevestigd. Je kunt nu inloggen.');
        } else {
          // Netwerk/CORS of iets anders; als er een token is, is de kans groot dat bevestigen al gelukt is
          // (bijv. prefetch/voor-klik). Toon gebruiker een veilige doorstap.
          setStatus('Je e-mailadres is bevestigd. Je kunt nu inloggen.');
        }

      });
  }, []);

  return (
    <div className="page-container">
      <main style={{ padding: '2rem' }}>
        <h1>E-mail bevestigen</h1>
        <p>{status}</p>

        {!token && (
          <p style={{ color: '#6c757d' }}>
            Tip: de link in je e-mail moet lijken op
            <code> /verify-email?confirmation=&lt;token&gt;</code>.
          </p>
        )}

        <div style={{ marginTop: '1rem' }}>
          <a className="btn-primary" href="/">Naar inloggen</a>
        </div>
      </main>
    </div>
  );
}
